module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"H.P.Leung","short_name":"H.P.Leung","start_url":"/","background_color":"#0F0F0F","theme_color":"#0F0F0F","display":"standalone","icon":"src/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"be17377226680f7ff254b252fd957640"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
